"use strict";
export var WarningSeverity = /* @__PURE__ */ ((WarningSeverity2) => {
  WarningSeverity2[WarningSeverity2["None"] = 0] = "None";
  WarningSeverity2[WarningSeverity2["Low"] = 1] = "Low";
  WarningSeverity2[WarningSeverity2["Medium"] = 5] = "Medium";
  WarningSeverity2[WarningSeverity2["High"] = 10] = "High";
  WarningSeverity2[WarningSeverity2["Blocked"] = 11] = "Blocked";
  return WarningSeverity2;
})(WarningSeverity || {});
export var WarningAction = /* @__PURE__ */ ((WarningAction2) => {
  WarningAction2["None"] = "none";
  WarningAction2["DisableReview"] = "disable_review";
  WarningAction2["WarnBeforeSubmit"] = "warn_before_submit";
  WarningAction2["WarnAfterRecipientSelect"] = "warn_after_recipient_select";
  WarningAction2["DisableSubmit"] = "disable_submit";
  return WarningAction2;
})(WarningAction || {});
export var WarningLabel = /* @__PURE__ */ ((WarningLabel2) => {
  WarningLabel2["EnterLargerAmount"] = "enter_larger_amount";
  WarningLabel2["InsufficientFunds"] = "insufficient_funds";
  WarningLabel2["InsufficientGasFunds"] = "insufficient_gas_funds";
  WarningLabel2["FormIncomplete"] = "form_incomplete";
  WarningLabel2["UnsupportedNetwork"] = "unsupported_network";
  WarningLabel2["PriceImpactMedium"] = "price_impact_medium";
  WarningLabel2["PriceImpactHigh"] = "price_impact_high";
  WarningLabel2["LowLiquidity"] = "low_liquidity";
  WarningLabel2["SwapRouterError"] = "swap_router_error";
  WarningLabel2["NoRoutesError"] = "no_routes_error";
  WarningLabel2["RateLimit"] = "rate_limit";
  WarningLabel2["RecipientZeroBalances"] = "recipient_zero_balances";
  WarningLabel2["RecipientNewAddress"] = "recipient_new_address";
  WarningLabel2["RecipientIsSmartContract"] = "recipient_is_smart_contract";
  WarningLabel2["ViewOnlyAccount"] = "view_only_account";
  WarningLabel2["NetworkError"] = "network_error";
  WarningLabel2["BlockedToken"] = "blocked_token";
  WarningLabel2["NoQuotesFound"] = "no_quotes_found";
  WarningLabel2["UsdValueMismatch"] = "usd_value_mismatch";
  return WarningLabel2;
})(WarningLabel || {});
